import MessagesService from 'js/services/api/citizen/messages'

import ChatMessage from './_chat-message'

import template from './_chat-panel.pug'

const MAXIMUM_CHAT_CONTENT_LENGTH = 500

// @vue/component
export default {
  template: template(),

  components: {ChatMessage},

  props: {
    message: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      chatMessages: [],
      content: undefined,
      errors: {}
    }
  },

  computed: {
    chatMaxLength() {
      return MAXIMUM_CHAT_CONTENT_LENGTH
    },

    buttonDisabled() {
      return (!this.content || (typeof this.content === 'string' && this.content.trim() === ''))
    },

    checkMessages() {
      if (this.chatMessages.length) return 'chat-content'
      return undefined
    },

    canSend(){
      // Disable based on state
      if(['closed'].includes(this.message.state)) return false

      // Disable based on chat_status
      return this.message.status_chat
    }
  },

  created() {
    
    // Chat messages are now included in the message on first load
    if(this.message.chatMessages)
      this.chatMessages = this.message.chatMessages
    else
      this.getChatMessages()
  },

  methods: {
    /*
     * Obtención de los mensajes de chat
     */
    getChatMessages() {
      MessagesService.chatMessages(this.message.id).then(chatMessages => {
        this.chatMessages = this.analizeChatMessages(chatMessages)
      })
    },

    analizeChatMessages(chatMessages) {
      const newChatMessages = []

      let previousUserType

      chatMessages.forEach(chatMessage => {
        chatMessage.userChange = chatMessage.sender_type !== previousUserType
        previousUserType = chatMessage.sender_type
        newChatMessages.push(chatMessage)
      })

      return newChatMessages
    },

    sendChatMessage() {
      MessagesService.createChatMessage(this.message.id, {content: this.content}).then(() => {
        this.$emit('reload-message')
        this.getChatMessages()
        this.content = undefined
      }, response => {
        if (response.status === 422) this.errors = response.body.errors
      })
    }
  }
}
